module.exports = __webpack_public_path__ + "admin-thumbs/s-testimonial-grid.png";